interface Permissions {
  posPage?: boolean;
  kdsPage?: boolean;
  reservationPage?: boolean;
  addExpensePage?: boolean;
  orderListingPage?: boolean;
  priceCheckerPage?: boolean;
  kdsOrdersPage?: boolean;
}

export interface IPosConfig {
  _id: string;
  code: string;
  isActive: boolean;
  isDeleted: boolean;
  isReserved: boolean;
  companyLogin: boolean;
  headerColor: string;
  backgroundColor: string;
  logoImg: Array<{
    url: string;
    webkitRelativePath: string;
    lastModified: number;
    name: string;
    size: number;
    type: string;
  }>;
  permissions?: Permissions;
  defaultLandingPage?: string;
  darkHeaderColor: string;
  logoutButtonColor: string;
  logoutButtonText: string;
  primaryButtonColor: string;
  primaryButtonHoverColor: string;
  primaryButtonTextColor: string;
  primaryButtonHoverTextColor: string;
  primaryButtonColorDarkmode: string;
  primaryButtonHoverColorDarkmode: string;
  primaryButtonTextColorDarkmode: string;
  primaryButtonHoverTextColorDarkmode: string;
  categoryButtonColor: string;
  categoryButtonHoverColor: string;
  categoryButtonColorDarkmode: string;
  categoryButtonHoverColorDarkmode: string;
  categoryButtonTextColor: string;
  categoryButtonTextColorDarkmode: string;
  categoryButtonHoverTextColor: string;
  categoryButtonHoverTextColorDarkmode: string;
  itemButtonColor: string;
  itemButtonHoverColor: string;
  itemButtonColorDarkmode: string;
  itemButtonHoverColorDarkmode: string;
  itemButtonTextColor: string;
  itemButtonTextColorDarkmode: string;
  itemButtonHoverTextColor: string;
  itemButtonHoverTextColorDarkmode: string;
  sizeButtonColor: string;
  sizeButtonHoverColor: string;
  sizeButtonColorDarkmode: string;
  sizeButtonHoverColorDarkmode: string;
  sizeButtonTextColor: string;
  sizeButtonTextColorDarkmode: string;
  sizeButtonHoverTextColor: string;
  sizeButtonHoverTextColorDarkmode: string;
  tableButtonColor: string;
  tableButtonColorDarkmode: string;
  tableButtonHoverColor: string;
  tableButtonHoverColorDarkmode: string;
  tableButtonTextColor: string;
  tableButtonTextColorDarkmode: string;
  tableButtonHoverTextColor: string;
  tableButtonHoverTextColorDarkmode: string;
  orderBarColor: string;
  orderBarColorDarkmode: string;
  orderBarTextColor: string;
  orderBarTextColorDarkmode: string;
  orderBarMenuTextColor: string;
  orderBarMenuTextColorDarkmode: string;
  orderBarStatusColor: string;
  orderBarStatusColorDarkmode: string;
  orderBarViewDetailsColor: string;
  orderBarViewDetailsColorDarkmode: string;
  orderBarViewDetailsTextColor: string;
  orderBarViewDetailsTextColorDarkmode: string;
  dealsBarTextColor: string;
  dealsBarTextColorDarkmode: string;
  dealsBarQuanitityxpriceColor: string;
  dealsBarQuanitityxpriceColorDarkmode: string;
  dealsDetailsColor: string;
  dealsDetailsColorDarkmode: string;
  popupColor: string;
  popupColorDarkmode: string;
  popupTextColor: string;
  popupTextColorDarkmode: string;
  popupPrimaryButtonColor: string;
  popupPrimaryButtonColorDarkmode: string;
  popupPrimaryButtonTextColor: string;
  popupPrimaryButtonTextColorDarkmode: string;
  popupSecondaryButtonColor: string;
  popupSecondaryButtonColorDarkmode: string;
  popupSecondaryButtonTextColor: string;
  popupSecondaryButtonTextColorDarkmode: string;
  itemsPriceTextColor: string;
  itemsPriceTextColorDarkmode: string;
  sizesPriceTextColor: string;
  sizesPriceTextColorDarkmode: string;
  addonsButtonColor: string;
  addonsButtonHoverColor: string;
  addonsButtonColorDarkmode: string;
  addonsButtonHoverColorDarkmode: string;
  addonsButtonTextColor: string;
  addonsButtonTextColorDarkmode: string;
  addonsButtonHoverTextColor: string;
  addonsButtonHoverTextColorDarkmode: string;
  addonsButtonPriceTextColor: string;
  addonsButtonPriceTextColorDarkmode: string;
  isRestaurant: string;
  background: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  enableOpenTillCloseTill: boolean;
  remoteCodeIdLength: number;
  customerTabAsDefaultTab: boolean;
  isCustomerInformationMandatory: boolean;
  updatedBy: string;
  batchNumberLength: number;
  enableBarcodePrintingModule: boolean;
  enableKitchenDisplayModule: boolean;
  enableReservationModule: boolean;
  productRefCodeLength: string;
  customcss: string;
  baseurl: string;
  cartposition: string;
  shortcuts: string;
  invoicereceipt: string;
  receiptlogo: Array<{
    url: string;
    webkitRelativePath: string;
    lastModified: number;
    name: string;
    size: number;
    type: string;
  }>;
}

const snake_case_string = (str: string | null) => {
  return (
    str &&
    str
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
      )
      ?.map((s: string) => s.toLowerCase())
      .join("_")
  );
};

const convertJsonToFormat = (jsonData: IPosConfig) => {
  const result: any = {};
  if (jsonData !== undefined) {
    let keys = Object.keys(jsonData);
    for (let i = 0; i < keys.length; i++) {
      result[`${snake_case_string(keys[i].toString())}`] =
        jsonData[keys[i] as keyof IPosConfig];
    }
  }
  return result;
};

export const loadPosConfig = async (): Promise<any> => {
  try {
    const response = await fetch("/config.json");
    const config: IPosConfig = await response.json();
    return convertJsonToFormat(config);
  } catch (error) {
    console.error("Failed to load config:", error);
    throw new Error("Failed to load POS configuration");
  }
};
